export function enUpper(value) {
  return String(value ?? '').toLocaleUpperCase('en-US');
}

const EN_CASING_SELECTOR = [
  '.header-nav',
  '.header-nav-item',
  '.header-nav-item__label',
  '.header__sub-link',
  '.live-wins__caption',
  '.live-wins__caption-title',
  '.live-wins__caption-line',
  '.top-wins__caption',
  '.top-wins__caption-title',
  '.top-wins__caption-line',
  '.grand-jackpot__badge',
  '.grand-jackpot__note',
  '.grand-jackpot__tier-name',
  '.grand-jackpot__box-label',
  '.game-card__name',
  '.game-card__name-line',
  '.game-card__provider',
  '.game-card__tag-text',
  '.casino-side-game-card__name',
  '.casino-side-game-card__name-line',
  '.casino-side-game-card__provider',
  '.casino-page__filter-section-caption',
].join(',');

export function applyEnCasingLang(root = document) {
  if (!root?.querySelectorAll) return;
  root.querySelectorAll(EN_CASING_SELECTOR).forEach((el) => {
    if (el.getAttribute('lang') !== 'en') el.setAttribute('lang', 'en');
  });
}

export function bindEnCasingLang(root = document.body) {
  if (!root) return () => {};
  applyEnCasingLang(root);
  const mo = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type !== 'childList') continue;
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const el = node;
        if (el.matches?.(EN_CASING_SELECTOR)) el.setAttribute('lang', 'en');
        applyEnCasingLang(el);
      });
    }
  });
  mo.observe(root, { childList: true, subtree: true });
  return () => mo.disconnect();
}
